// @ts-nocheck
import React , {useState} from "react";
import {AREA_WIFI, RUTA_API_ALIAS, RUTA_API_AREAS, RUTA_API_USUARIOS, URL_API_SIA} from "../../Contantes/Constantes";
import {useBody} from "../../Body/state/BodyContext";
import axios from "axios";
import {setupInterceptorsTo} from "../../Componentes/API/AxiosBuilder";
import { UsuarioContext } from "./UsuarioContext";
import {EXTENSION_MAIL_INSTITUCIONAL} from "../../Contantes/Constantes";
import { uid as uidGenerator} from "uid";

export function ProvideUsuarios({ children }) {
    const emails = useProvideUsuarios();
    return (
        <UsuarioContext.Provider value={emails}>
            {children}
        </UsuarioContext.Provider>
    );
}

function useProvideUsuarios() {
    const {setMessage,setSuccess} = useBody();
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const axiosInstance = setupInterceptorsTo(axios.create());
    const [provincias, setProvincias] = useState([]);
    const [paises, setPaises] = useState([]);
    const [estadoGoogle, setEstadoGoogle] = useState(false);
    const [estadoLDAP, setEstadoLDAP] = useState(false);
    const [estado404Google, setEstado404Google] = useState(false);
    const [estadoAD, setEstadoAD] = useState(false);
    const [hasSolicitudAD, setHasSolicitudAD] = useState(false);
    const [estadoVPN, setEstadoVPN] = useState(false);
    const [estadoWIFI, setEstadoWIFI] = useState(false);
    const [usuario,setUsuario] = useState({
        nombre: '',
        apellido: '',
        uid: '',
        frbaEmail: EXTENSION_MAIL_INSTITUCIONAL,
        fechaNacimiento: null,
        SexoId: 0,
        SedeId: 0,
        password: '',
        repeat_password: '',
        FiliacionId: 0,
        telefonoDomiciliario: '',
        telefonoCelular: '',
        personalEmail: '',
        legajoAlumno: '',
        legajoPersonaUTN: '',
        nacionalidad: 0,
        DocumentoDeIdentificacion: {
            numero : '',
            TipoDocumentoDeIdentificacionId : 0
        }
    });
    const [aliasDirectos,setAliasDirectos] = useState([]);
    const [aliasIndirectos, setAliasIndirectos] = useState([]);
    const [altasPendientes, setAltasPendientes] = useState([]);
    const [solicitudes, setSolicitudes] = useState([
        {
            id: 0,
            nombreSolicitante: "",
            emailDestinatario: "",
            tiempoRestante: "",
            uuid: ""
        }

    ]);

    /**
     * ------------------------------------------
     *          ALTA DE USUARIOS
     * ------------------------------------------
     */

    React.useEffect( () => {
        const obtenerInfoAPISExternas = async () => {
            await getNacionalidades();
            await getProvincias("Argentina")
        }

        obtenerInfoAPISExternas().then(setLoading(false))
    }
    
    , [])

    const getProvincias = (pais) => {
        axios({
            method: 'GET',
            url: RUTA_API_USUARIOS + '/formulario/states'
        }).then((response) => {
            const mapprovincias = response.data
            setProvincias(mapprovincias)
        })
        .catch(error => {
                setMessage("Ocurrio un error al querer obtener las provincias (Codigo de error: 00044), intente de nuevo mas tarde");
        })
    }

    const getNacionalidades = () => {
        axios({
            method: 'GET',
            url: 'https://countriesnow.space/api/v0.1/countries/info?returns=name'
        }).then((response) => {
            const mappaises = response.data.data.map(pais => pais.name).sort();
            setPaises(mappaises)
        })
        .catch(() => {
            setMessage("Ocurrio un error al querer obtener los paises (Codigo de error: 00045)");
        })
    }

    const mapearInformacion = (solicitudes) => {

        const adapt_response = solicitudes.map(solicitud => ({
            id: solicitud.id,
            nombreSolicitante: solicitud.nombreSolicitante,
            emailDestinatario: solicitud.emailDestinatario,
            tiempoRestante: solicitud.fechaLimite,
            uuid: solicitud.uuid
        }))


        setSolicitudes(adapt_response)
    }

    const getSolicitudes = () => {
        axiosInstance({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/solicitudes/registro/`,
        })
            .then((response) => {
                mapearInformacion(response.data)
            })
            .catch(() => {
                setMessage("Ocurrio un error al querer obtener información de solicitudes (Codigo de error: 00037)");
            })
            .then(setLoading(false));
    }

    const adapterAltasPendientes = (response) => {
        const altasPendientes = response.map( (usuario) => ({
            nombre: usuario.nombre,
            apellido: usuario.apellido,
            frbaEmail: usuario.frbaEmail,
            uid: usuario.frbaEmail.match(/^([^@]*)@/)[1],
            email_personal: usuario.email_personal
        }))
        setAltasPendientes(altasPendientes);
        return altasPendientes;
    }

    const getAltasPendientes = async () => {
      try {
        const response = await axiosInstance({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/users/`
        })
        const altasPendientes = await adapterAltasPendientes(response.data);
        return altasPendientes;
      } catch (error) {
        console.error("Error al obtener altas pendientes:", error);
        setMessage(
          "Ocurrió un error al querer obtener altas pendientes de usuarios (Código de error: 00039)"
        );
      }
    };

    /**
     * ------------------------------------------
     *          GESTION DE USUARIOS
     * ------------------------------------------
     */

    const getUsuarios = async () =>  {
        await axiosInstance({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/ldap/users/obtener/ultimos`
        }).then( response => {
            setUsuarios(response.data)
        }).catch(error => {
            setMessage("Ocurrio un error al querer obtener los ultimos usuarios (Codigo de error: 00046)")
        })
    }

    /**
     *
     * @param valor Es el init string de nombre o apellido o uid
     * @returns {Promise<void>}
     */
    const fetchUsuariosBuscado = async (valor, signal, filtro) => {
        if (valor === "") {
            getUsuarios();
            return;
        }

        try {
            const response = await axiosInstance.get(`${RUTA_API_USUARIOS}/ldap/users/init/${filtro}/${valor}`, { signal });
            setUsuarios(response.data);
        } catch (error) {
            if (error.name !== "AbortError") { // Ignoramos los errores de cancelación
                setMessage("Ocurrió un error al obtener los usuarios con ese valor (Código de error: 00047)");
            }
        }
    };


    const fetchUsuarioBuscado = async (uid) => {
        await axiosInstance({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/ldap/users/${uid}`
        }).then( response => {
            setUsuario(response.data)
        }).catch(error => {
            console.error("Ocurrio un error al querer obtener el estado de suspencion del usuario en LDAP (Codigo de error: 00048)")
        })
    }

    const fetchEstadoUsuarioEnGoogle = async (frbaEmail) => {
        await axiosInstance({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/ldap/users/google/${frbaEmail}/suspended`
        }).then( response => {
            setEstadoGoogle(!response.data)
            setEstado404Google(false);
        }).catch(error => {
            if (error.response.status === 404) {
                setMessage("El usuario no pudo ser encontrado en el dominio de Google")
                setEstado404Google(true);
            }
            else
                setMessage("Ocurrio un error al querer obtener el estado de suspencion del usuario en Google (Codigo de error: 00048)")
        })
    }

    const fetchEstadoUsuarioEnLDAP = async (uid) => {
        await axiosInstance({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/ldap/users/account/${uid}/suspended`
        }).then( response => {
            setEstadoLDAP(!response.data)
            return !response.data
        }).catch(error => {
            setMessage("Ocurrio un error al querer obtener la información del usuario (Codigo de error: 00049)")
        })
    }
    const fetchEstadoUsuarioEnAD = async (uid) => {
        await axiosInstance({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/activedirectory/${uid}`
        }).then( response => {
            setEstadoAD(response.data.success)
        }).catch(error => {
            setMessage("Ocurrio un error al querer obtener la información del usuario (Codigo de error: 00054)")
        })
    }

    const fetchEstadoUsuarioEnVPN = async (uid) => {
        await axiosInstance({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/vpn/${uid}`
        }).then( response => {
            setEstadoVPN(response.data)
        }).catch(error => {
            setMessage("Ocurrio un error al querer obtener la información del usuario (Codigo de error: 00054)")
        })
    }

    const addUserVPN = async (uid) => {
       await axiosInstance({
            method: 'POST',
            url: `${RUTA_API_USUARIOS}/vpn/${uid}`
        }).then( response => {
            setEstadoVPN(true)
        }).catch(error => {
            setMessage("Ocurrio un error al querer obtener la información del usuario (Codigo de error: 00054)")
        })
    }

    const deleteUserVPN = async (uid) => {
        await axiosInstance({
             method: 'DELETE',
             url: `${RUTA_API_USUARIOS}/vpn/${uid}`
         }).then( response => {
             setEstadoVPN(false)
         }).catch(error => {
             setMessage("Ocurrio un error al querer obtener la información del usuario (Codigo de error: 00054)")
         })
    }

    // Para Grupo WIFI

    const fetchEstadoUsuarioEnWIFI = async (uid) => {
        try {
            const response = await axiosInstance({
                method: 'GET',
                url: `${RUTA_API_USUARIOS}/ldap/users/members/group?group=${AREA_WIFI}`
            });

            const miembros = response.data[0]?.memberUid || [];

            const estaEnWifi = miembros.includes(uid);
            setEstadoWIFI(estaEnWifi);
        } catch (error) {
            console.error(error);
            setMessage("Ocurrió un error al querer obtener la información del usuario (Código de error: 00054)");
        }
    };


    const addUserWIFI = async (uid) => {
        const body = {
            uid: uid
        }
        await axiosInstance({
            method: 'POST',
            url: `${RUTA_API_USUARIOS}/ldap/users/members/group/wifi`,
            data: body
        }).then( response => {
            setSuccess("Usuario agregado al grupo WIFI con exito")
            setEstadoWIFI(true)
        }).catch(error => {
            setMessage("Ocurrio un error al querer obtener la información del usuario (Codigo de error: 00054)")
        })
    }

    const deleteUserWIFI = async (uid) => {
        const body = {
            uid: uid
        }
        await axiosInstance({
            method: 'DELETE',
            url: `${RUTA_API_USUARIOS}/ldap/users/members/group/wifi`,
            data: body
        }).then( response => {
            setSuccess("Usuario eliminado del grupo WIFI con exito")
            setEstadoWIFI(false)
        }).catch(error => {
            setMessage("Ocurrio un error al querer obtener la información del usuario (Codigo de error: 00054)")
        })
    }

    const createUserInAD = async (uid) => {
        await axiosInstance({
            method: 'POST',
            url: `${RUTA_API_USUARIOS}/activedirectory/solicitudAD/${uid}`
        }).then( response => {
            setEstadoAD(true)
            setSuccess(response.data)
        }).catch(error => {
            setMessage("Ocurrio un error al querer crear el usuario en el Active Directory (Codigo de error: 00055)")
        })
    }
    const checkSolicitudUserInAD = async (uid) => {
        await axiosInstance({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/activedirectory/solicitudADID/${uid}`
        }).then( response => {
            setHasSolicitudAD(response.data)
        }).catch(error => {
            setMessage("Ocurrio un error al querer crear el usuario en el Active Directory (Codigo de error: 00055)")
        })
    }
    const deleteUserInAD = async (uid) => {
        await axiosInstance({
            method: 'DELETE',
            url: `${RUTA_API_USUARIOS}/activedirectory/${uid}`
        }).then( response => {
            setEstadoAD(false)
        }).catch(error => {
            setMessage("Ocurrio un error al querer eliminar el usuario del Active Directory (Codigo de error: 00056)")
        })
    }

    const deshabilitarCuentaGoogle = async (frbaEmail,nuevoEstado,email) => {
        await axiosInstance({
            method: 'PUT',
            url: `${RUTA_API_USUARIOS}/ldap/users/google/suspended`,
            data: {
                mail: frbaEmail,
                suspended: !nuevoEstado,
                mailDestinatario: email // tiene que ser el mail alternativo
            }
        }).then(response => {
            setEstadoGoogle(nuevoEstado)
        }).catch( error =>
            setMessage("Ocurrió un error al querer cambiar el estado de la cuenta de Google (Código de error: 00050)")
        )
    }

    const deshabilitarCuentaLDAP = async (uid,nuevoEstado,email) => {
        await axiosInstance({
            method: 'PUT',
            url: `${RUTA_API_USUARIOS}/ldap/users/account/suspended`,
            data: {
                uid: uid,
                suspended: !nuevoEstado,
                mailDestinatario: email, // tiene que ser el mail alternativo
                password: uidGenerator(16)
            }
        }).then(response => {
            setEstadoLDAP(nuevoEstado)
        }).catch( error => {
                setMessage("Ocurrió un error al querer cambiar el estado de la cuenta de LDAP (Código de error: 00051)")
            }
        )
    }

    const handleSuspend = async (value,userinfo) => {
        await axiosInstance({
            method: 'PUT',
            url: RUTA_API_USUARIOS+ '/ldap/users/modificar/password',
            data: {

                user: {
                    uid: userinfo.uid,
                    mail: userinfo.frbaEmail
                },
                motivo: value,
                mail: userinfo.personalEmail
            }
        }).then(response => setSuccess('El usuario se suspendió con exito'))
            .catch(error => setMessage('Hubo un error al querer suspender al usuario (Código de error: 00052)'))
    }

    const getAliasDeUsuario = async (uid) => {
        await axiosInstance({
            method: 'GET',
            url: RUTA_API_ALIAS + `/user/${uid}`
        }).then(response => {
            setAliasDirectos(response.data.directos);
            setAliasIndirectos( response.data.indirectos);
        }).catch(error => setMessage("Hubo un error al querer obtener las alias del usuario (Código de error: 00053)"));
    }


    return {
        usuarios , setUsuarios , getProvincias, getNacionalidades, provincias, paises, loading, setLoading, solicitudes, getSolicitudes, getAltasPendientes, altasPendientes, setAltasPendientes
        , getUsuarios, fetchUsuariosBuscado, fetchUsuarioBuscado, usuario, setUsuario, estadoGoogle, setEstadoGoogle, fetchEstadoUsuarioEnGoogle, fetchEstadoUsuarioEnLDAP, estadoLDAP, setEstadoLDAP,fetchEstadoUsuarioEnVPN, estadoVPN,addUserVPN, deleteUserVPN ,fetchEstadoUsuarioEnAD, checkSolicitudUserInAD, estadoAD, setEstadoAD, createUserInAD, hasSolicitudAD, deleteUserInAD
        ,deshabilitarCuentaGoogle, deshabilitarCuentaLDAP, handleSuspend, getAliasDeUsuario, aliasDirectos, aliasIndirectos, estado404Google, estadoWIFI, fetchEstadoUsuarioEnWIFI, addUserWIFI, deleteUserWIFI
    };
}
